/*eslint-disable*/
import React, { Suspense } from "react";
import { withRouter } from "react-router-dom";
import { Tab } from "semantic-ui-react";
import {
  Card,
  CardBody,
  Row,
  Col,
  CardHeader,
  CardFooter,
  Label,
  CardTitle,
} from "reactstrap";
import ContentWrapper from "../../../../template/Layout/ContentWrapper";
import axios from "axios";
import SumaryContainer from "./Components/Sumary";
import EventsContainer from "./Components/Events/EventsContainer";
import { Link } from "react-router-dom";


import { Services } from "../../Services";

// import Arrival from './components/Arrival'
// import '../cards.scss'

class ContainersDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          label: "Booking request",
          value: "",
          id: 1,
          completed: false,
          order: 1,
          idStep: "step1",
          middleStep: "",
        },
        {
          label: "Booking Confirmation",
          value: "",
          id: 2,
          completed: false,
          order: 2,
          idStep: "step2",
          middleStep: "",
        },
        {
          label: "ATD",
          value: "",
          id: 4,
          completed: false,
          order: 3,
          idStep: "step3",
          middleStep: "",
        },
        {
          label: "ATA",
          value: "",
          id: 5,
          completed: false,
          order: 4,
          idStep: "step4",
          middleStep: "",
        },
        {
          label: "Out of Gate",
          value: "",
          id: 8,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
        },
        {
          label: "Empty Returned",
          value: "",
          id: 9,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
        },
      ],
      allSteps: [],
      id: props.match.params.id ? props.match.params.id : props.idContainer,
      dataContainer: [],
      allTables: [],
    };
  }

  getContainerId = () => {
    axios
      .get(
        `${Services.Get_ContainerId.path}shipments/dataContainer/${this.state.id}`
      )
      .then((response) => {
        this.setState({
          dataContainer: response.data.data[0],
          // tables: newTabla,
          // key: Math.random()
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  componentWillMount = () => {
    this.getContainerId();
    this.getEvents();
  };

  getEvents = () => {
    const { steps, id } = this.state;
    let moduleId = 2;
    axios
      .get(`${Services.Get_Events_General.path}events/all/${moduleId}/${id}`)
      .then((response) => {
        var newSteps = steps;
        let dataEvents = response.data.data;
        var findNext = false;
        newSteps.map((f) => {
          dataEvents.map((e) => {
            if (e.EventDescriptionId === f.id) {
              findNext = true;
              f.value = e.EventDate;
              if (e.InTimeLine === "1") {
                f.completed = true;
              } else {
                findNext = false;
              }
            } else {
              findNext = false;
            }
            if (findNext) {
              f.completed = true;
            }
            return e;
          });
          return f;
        });
        newSteps.sort(function (a, b) {
          return b.order - a.order;
        });
        let findTrue = false;
        newSteps.map((e) => {
          if (e.completed) {
            findTrue = true;
          }
          if (findTrue) {
            e.completed = true;
          }
          return e;
        });
        newSteps.sort(function (a, b) {
          return a.order - b.order;
        });

        this.setState({ steps: newSteps, allSteps: dataEvents }, () => { });
      })
      .catch((error) => { });
  };

  render() {
    let { dataContainer } = this.state;
    return (
      <>
        {
          this.props.match.params.id ?
            <ContentWrapper>
              <div className="content-heading">
                <i className="fas fa-shopping-basket mr-2"></i>
                <b>Container Details</b>
              </div>
              <div>
                <Tab
                  menu={{ secondary: true }}
                  panes={[
                    {
                      menuItem: "Summary",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          <SumaryContainer
                            data={dataContainer}
                            getContainerId={this.getContainerId}
                            steps={this.state.steps}
                            allSteps={this.state.allSteps}
                          />
                        </Suspense>
                      ),
                    },
                    {
                      menuItem: "Events",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          {" "}
                          <EventsContainer
                            data={dataContainer}
                            steps={this.state.steps}
                            allSteps={this.state.allSteps}
                          ></EventsContainer>
                        </Suspense>
                      ),
                    },

                    // { menuItem: 'Arrival', render: () => <Suspense fallback={<div>Loading...</div>}><Arrival /> </Suspense> },
                  ]}
                />
              </div>
            </ContentWrapper>
            :
            <div className="content">
              <hr></hr>
              <Col className='d-flex align-items-center'
                onClick={this.props.getIdContainer}
                style={{ cursor: 'pointer', padding: 0 }} >
                <div className='link-containers d-flex flex-row align-items-center'>
                  <i className='fas fa-arrow-circle-left fa-3x mr-2' />
                  <span><h4><b>Back Containers</b></h4></span>
                </div>
              </Col>
              <br></br>
              <div>
                <Tab
                  menu={{ secondary: true }}
                  panes={[
                    {
                      menuItem: "Summary",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          <SumaryContainer
                            data={dataContainer}
                            getContainerId={this.getContainerId}
                            steps={this.state.steps}
                            allSteps={this.state.allSteps}
                          />
                        </Suspense>
                      ),
                    },
                    {
                      menuItem: "Events",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          {" "}
                          <EventsContainer
                            data={dataContainer}
                            steps={this.state.steps}
                            allSteps={this.state.allSteps}
                          ></EventsContainer>
                        </Suspense>
                      ),
                    },
                  ]}
                />
              </div>
            </div>
        }
      </>
    );
  }
}

export default withRouter(ContainersDetail);
